/**
 * Returns a sqm string or dash
 * @param {string | number | null} value - Any value
 * keywords: sqm
 */
const asSqm = (value?: string | number | null): string =>
  value ? `${value} m²` : '-';

export default asSqm;
